import { SafeArea } from 'capacitor-plugin-safe-area'
import { Capacitor } from '@capacitor/core'
import StatusBarManager from '@/utils/StatusBarManager'

let safeAreaListener = null
const isNative = Capacitor.getPlatform() !== 'web'

function setInsetsToCSS(insets) {
    if (!insets) return

    Object.entries(insets).forEach(([key, value]) => {
        document.documentElement.style.setProperty(
            `--safe-area-inset-${key}`,
            `${value}px`
        )
    })
}

async function init() {
    if (!isNative) return;
    try {
        await SafeArea.setImmersiveNavigationBar()
        await StatusBarManager.refresh()
        const { insets } = await SafeArea.getSafeAreaInsets()
        setInsetsToCSS(insets)
        safeAreaListener = await SafeArea.addListener(
            'safeAreaChanged',
            (data) => {
                setInsetsToCSS(data.insets)
            }
        )
    } catch (err) {
        console.warn('SafeArea error:', err)
    }
}

async function refresh() {
    if (!isNative) return;
    try {
        const { insets } = await SafeArea.getSafeAreaInsets()
        setInsetsToCSS(insets)
    } catch (err) {
        console.warn('SafeArea refresh error:', err)
    }
}

async function destroy() {
    if (!isNative) return;
    if (safeAreaListener) {
        await safeAreaListener.remove()
        safeAreaListener = null
    }
}

export default {
    init,
    refresh,
    destroy
}
